import { PureComponent } from 'react';
import { Button, Modal, Icon } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

class UnsavedNoteModalBase extends PureComponent {
  render() {
    const { t, unSavedNoteModal, toggleUnSavedNoteModal, onConfirmQuit } =
      this.props;

    return (
      <Modal
        open={unSavedNoteModal}
        closeIcon={
          <Icon
            onClick={() => {
              toggleUnSavedNoteModal(false);
            }}
            name="close"
            className="closeicon"
          />
        }
        size="tiny"
      >
        <Modal.Header className="warning-header-text">
          {t('common.are_you_sure_you_want_to_leave')}
        </Modal.Header>
        <Modal.Content className="warning-content-text">
          {t('common.you_have_unsaved_changes')}
        </Modal.Content>

        <Modal.Actions>
          <div className="model-buttons">
            <Button
              onClick={() => toggleUnSavedNoteModal(false)}
              className="Primary-Button mr-2"
            >
              {t('actions.stay')}
            </Button>
            <Button
              onClick={() => {
                onConfirmQuit();
              }}
              className="Secondary-Button"
              content={t('actions.leave')}
            />
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

export const UnsavedNoteModal = withTranslation()(UnsavedNoteModalBase);
